import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColorRoll: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColorRoll"><Path d="M6 3H21V11H6V7.75H4.5V12.5H13.75V15.3445C15.0439 15.6775 16 16.8521 16 18.25V22H14.5V18.25C14.5 17.4216 13.8284 16.75 13 16.75C12.1716 16.75 11.5 17.4216 11.5 18.25V22H10V18.25C10 16.8521 10.9561 15.6775 12.25 15.3445V14H3V6.25H6V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColorRoll;
